import { render, staticRenderFns } from "./ProjectLoginButton.vue?vue&type=template&id=7fdc00ef&lang=pug&"
import script from "./ProjectLoginButton.vue?vue&type=script&lang=js&"
export * from "./ProjectLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectLoginButton.vue"
export default component.exports